const initCalculator = () => {
  const calculator = document.querySelector(".forecast__calculation");
  if (!calculator) return;
  const totalPrice = calculator.querySelector("[data-total-price]");
  const countInput = calculator.querySelector("input[name=count]");
  const minusButton = calculator.querySelector("[data-minus]");
  const plusButton = calculator.querySelector("[data-plus]");

  minusButton.addEventListener("click", () => {
    let currentValue = +countInput.value - 1;
    if (currentValue >= 1) {
      countInput.value = currentValue;
    }
    totalPrice.textContent = 1500 * +countInput.value
  })

  plusButton.addEventListener("click", () => {
    let currentValue = +countInput.value + 1;
    if (currentValue <= 100) {
      countInput.value = currentValue;
    }
    totalPrice.textContent = 1500 * +countInput.value
  });

  countInput.addEventListener("input", (evt) => {
    if (evt.target.value < 1) {
      countInput.value = 1;
    } else if (evt.target.value > 100) {
      countInput.value = 100;
    } else {
      countInput.value = evt.target.value;
    }
    totalPrice.textContent = 1500 * +countInput.value
  })
};

export default initCalculator;
